import {Injectable} from '@angular/core';
import {ToolbarItemSaveDisabledCheckService} from "./toolbar-item-save-disabled-check.service";


@Injectable()
export class ToolbarItemCancelDisabledCheckService extends ToolbarItemSaveDisabledCheckService {
}
